/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureEmailNotificationSenderV1Dto = {
  /**
   * Approval status
   */
  type: SignatureEmailNotificationSenderV1Dto.type;
  /**
   * The custom name of the sender
   */
  custom_name?: string | null;
};
export namespace SignatureEmailNotificationSenderV1Dto {
  /**
   * Approval status
   */
  export enum type {
    CUSTOM = 'custom',
    ORGANIZATION = 'organization',
    USER = 'user',
    WORKSPACE = 'workspace',
  }
}
